import Vue     from "vue";
import VueI18n from "vue-i18n";

import bg from "./locales/bg.js";
import en from "./locales/en.js";
import ru from "./locales/ru.js";

Vue.use(VueI18n);

const messages = {
    "bg": bg,
    "en": en,
    "ru": ru
}

const i18n = new VueI18n({
    locale: "ru",           // set locale
    fallbackLocale: "en",   // set fallback locale
    messages,               // set locale messages
});

export default i18n;
